import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { concat, forkJoin, Subscription } from 'rxjs';
import { BaseClass } from 'src/app/shared/models/base-class';
import { LanguageService } from 'src/app/shared/services/common/language.service';
import { StorageManagerService } from 'src/app/shared/services/common/storage-manager.service';
import { AuthService } from 'src/app/shared/services/rest/auth.service';
import { CompanyService } from 'src/app/shared/services/rest/company.service';
import { environment } from 'src/environments/environment';
import { ChatsComponent } from '../chats/chats.component';
import { PartnersListComponent } from '../main/dialogs/partners/partners-list/partners-list.component';

@Component({
  selector: 'app-workspace-settings',
  templateUrl: './workspace-settings.component.html',
  styleUrls: ['./workspace-settings.component.scss']
})
export class WorkspaceSettingsComponent extends BaseClass implements OnInit, OnDestroy {
  public isExpanded: boolean = true;
  public activeTab: any;
  public activeSubTab: any;
  public activeParentTab: any;
  public company_id: any;
  public users: any;
  public parameters: any;
  public host: any = environment.host;
  public imgRoute: any = '';
  public activeLang: any;
  public user: any = {};
  public user_id: number;
  public company: any;
  public menuItems: any[] = [
    {
      icon: 'account_balance',
      name: 'Finances',
      tab: 'finances_dashboard',
      activeIf: ['finances_dashboard', 'finances', 'current_activity'],
      subItems: [
        {
          name: 'Statements',
          tab: 'finances',
          subTab: 'statements'
        },
        {
          name: 'Payouts',
          tab: 'finances',
          subTab: 'payouts'
        },
      ]
    },
    {
      icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 5H13V7H9V9H11C11.5304 9 12.0391 9.21071 12.4142 9.58579C12.7893 9.96086 13 10.4696 13 11V13C13 13.5304 12.7893 14.0391 12.4142 14.4142C12.0391 14.7893 11.5304 15 11 15H7V13H11V11H9C8.46957 11 7.96086 10.7893 7.58579 10.4142C7.21071 10.0391 7 9.53043 7 9V7C7 6.46957 7.21071 5.96086 7.58579 5.58579C7.96086 5.21071 8.46957 5 9 5ZM10 0C11.3132 0 12.6136 0.258658 13.8268 0.761205C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C17.9997 3.85752 18.7362 4.95991 19.2388 6.17317C19.7413 7.38642 20 8.68678 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C8.68678 20 7.38642 19.7413 6.17317 19.2388C4.95991 18.7362 3.85752 17.9997 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2Z" fill="black"/></svg>',
      name: 'Automation',
      tab: 'automation',
      activeIf: ['automation', 'checklists', 'scenarios_queue'],
      subItems: [
        {
          name: 'Checklists',
          tab: 'checklists'
        },
        {
          name: 'Scenarios Queue',
          tab: 'scenarios_queue'
        }
      ]
    },
    {
      icon: 'badge',
      name: 'Workspace Members',
      tab: 'workspace_members',
      activeIf: [ 'workspace_members', 'individuals', 'partner_workspaces', 'questionnaires', 'users'],
      subItems: [
        {
          name: 'Individuals',
          tab: 'individuals'
        },
        {
          name: 'Schedules',
          tab: 'schedules'
        },
        {
          name: 'Partner Workspaces',
          tab: 'partner_workspaces'
        },
        {
          name: 'Onboarding forms',
          tab: 'questionnaires'
        },
        {
          name: 'Users',
          tab: 'users'
        }
      ]
    },
    {
      icon: 'category',
      name: 'Categorization',
      tab: 'categorization',
      activeIf: [ 'categorization', 'structure', 'task_types', 'job_types', 'company', 'bookmarks', 'parameters'],
      subItems: [
        {
          name: 'Company structure',
          tab: 'structure'
        },
        {
          name: 'Card Types',
          tab: 'task_types'
        },
        {
          name: 'Job Types',
          tab: 'job_types'
        },
        {
          name: 'Groups',
          tab: 'company'
        },
        {
          name: 'Presets',
          tab: 'bookmarks'
        },
        {
          name: 'Tags',
          tab: 'parameters'
        }
      ]
    },
    {
      icon: 'public',
      name: 'Outlets',
      tab: 'profiles',
      activeIf: ['profiles', 'sftp', 'manage-auth'],
      subItems: [
        {
          name: 'Youtube Partner CMS',
          tab: 'sftp'
        },
        {
          name: 'Authorizations',
          tab: 'manage-auth'
        },
        {
          name: 'Import Data',
          tab: 'import-data'
        }
      ]
    },
    {
      icon: 'data_usage',
      name: 'Usage',
      tab: 'usage',
      activeIf: [ 'usage', 'vpu_usage', 'total_usage', 'dubbing_usage', 'speech_to_text', 'text_to_speech', 'ai_usage'],
      subItems: [
        {
          name: 'Video Processing Units (VPU)',
          tab: 'vpu_usage'
        },
        {
          name: 'Storage usage',
          tab: 'total_usage'
        },
        {
          name: 'Dubbing',
          tab: 'dubbing_usage'
        },
        {
          name: 'Speech to Text',
          tab: 'speech_to_text'
        },
        {
          name: 'Text to Speech',
          tab: 'text_to_speech'
        },
        {
          name: 'AI usage',
          tab: 'ai_usage'
        }
      ]
    },
    {
      icon: 'point_of_sale',
      name: 'Billing',
      tab: 'billing',
      activeIf: ['billing', 'transactions', 'my_services', 'promos'],
      subItems: [
        {
          name: 'Transactions',
          tab: 'transactions'
        },
        {
          name: 'My services',
          tab: 'my_services'
        },
        {
          name: 'Promos',
          tab: 'promos'
        },
      ]
    },
    {
      icon: 'event_busy',
      name: 'Discontinued sections',
      tab: 'discontinued',
      is_root: true,
      activeIf: ['discontinued', 'stats', 'chats'],
      subItems: [
        {
          name: 'Stats',
          tab: 'stats'
        },
        {
          name: 'Chats',
          tab: 'chats'
        },
      ]
    },
    {
      icon: 'edit',
      name: 'Edit',
      tab: 'edit',
      is_owner: true,
      activeIf: ['edit'],
      subItems: [
      ]
    }
  ]

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private auth: AuthService,
    private languageService: LanguageService,
    private companyService: CompanyService,
    private sm: StorageManagerService
  ) { 
    super()
   }

  ngOnInit(): void {
    this.company_id = +this.activatedRoute.snapshot.queryParamMap.get('company_id');
    this.getUser();
    this.getCompany();
    this.getLangData();
    this.getImgRoute();
    this.getCsrf();
    this.attachSubscriptions(
      this.activatedRoute.queryParams.subscribe(resp => {
        this.activeTab = this.activatedRoute.snapshot.queryParamMap.get('page');
        this.activeSubTab = this.activatedRoute.snapshot.queryParamMap.get('tab');
        if (this.menuItems.find(x => !!x.activeIf.includes(this.activeTab))) {
          this.activeParentTab = this.menuItems.find(x => !!x.activeIf.includes(this.activeTab)).tab
        }
        this.company_id = +this.activatedRoute.snapshot.queryParamMap.get('company_id');
        this.getCompany();
        switch (this.activeTab) {
          case 'companyes':
            // this.getRootCompany()
            break;
          case 'users':
            // this.getRootUsers()
            break;
          case 'parameters':

            break;
        
          default:
            break;
        }
        console.log(resp)
      })
    )
  }

  getCompany() {
    this.attachSubscriptions(
      this.companyService.getCompany(this.company_id).subscribe(resp => {
        this.companyService.company$.next(resp[0]);
        this.company = resp[0];

        if (this.company.permissions.includes('admin') || this.company.permissions.includes('owner')) {
          if (this.menuItems[0].subItems.filter(x => x.name == 'Current Activity').length == 0) {
            this.menuItems[0].subItems.unshift({
              name: 'Current Activity',
              tab: 'finances',
              subTab: 'current_activity'
            })
          }
        }
        if ((this.company.permissions.includes('admin') || this.company.permissions.includes('hr')) && this.menuItems[2].subItems.filter(x => x.name == "Form").length == 0) {
          
          this.menuItems[2].activeIf.splice(4, 0, "form");
          this.menuItems[2].subItems.splice(3, 0, {
            name: 'Form',
            tab: 'form'
          })
          this.activeParentTab = this.menuItems.find(x => !!x.activeIf.includes(this.activeTab)).tab
        }
      })
    )
  }

  getImgRoute() {
    this.attachSubscriptions(
      this.sm.getImgPath().subscribe(el => {
        this.imgRoute = el;
      })
    )
  }

  getCsrf() {
    this.attachSubscriptions(
      this.auth.$userToken.subscribe(resp => {
        this.user_id = resp.user_id;
        this.sm.localStorageSetItem("csrf_param", resp.csrf_param)
        this.sm.localStorageSetItem("csrf_token", resp.csrf_token)
      })
    )
  }

  getLangData() {
    this.attachSubscriptions(
      this.languageService.getLangData().subscribe(resp => {
        this.activeLang = resp.active;
      })
    )
  }

  getUser() {
    this.attachSubscriptions(
      this.auth.$user.subscribe(resp => {
        this.user = resp;
      })
    )
  }

  goToChat() {
    const dialogRef = this.dialog.open(ChatsComponent, {
      backdropClass: ['backdrop_under_header', "without_pad"],
      disableClose: true,
      panelClass: ['full_screen_dialog', 'global_chats_dialog'],
      data: {
        company: this.company,
        user: this.user,
        imgRoute: this.imgRoute,
        dialogType: 'global_chat',
        host: this.host,
        activeLang: this.activeLang
      }
    });

    this.attachSubscriptions(
      dialogRef.afterClosed().subscribe(result => {
        if (!!result && result.event == 'update') {
        }
      })
    )
  }

  goToMenuItem(item) {
    if (item.tab == 'chats') {
      this.goToChat()
    } else if (item.hasOwnProperty("subTab")) {
      this.router.navigate(['/settings'], { queryParams: {company_id: this.company_id, page: item.tab, tab: item.subTab}});
    } else {
      this.router.navigate(['/settings'], { queryParams: {company_id: this.company_id, page: item.tab}});
    }
  }

  ngOnDestroy(): void {
    this.clearSubscriptions()
  }

}
